
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Vue, { PropType } from 'vue';
import Icon from '~/components/builders/Base/Icon.vue';
import Modal from '~/components/builders/Base/Modal.vue';
import { VFair } from '~/services/types/vfair';
import AddToCalendarButton from './AddToCalendarButton.vue';
import DateRange from './DateRange.vue';

interface DataType {
    isLoading: boolean;
    modalOpen: boolean;
}

export default Vue.extend({
    name: 'RegisterSuccessModal',
    components: {
        Modal,
        Icon,
        DateRange,
        AddToCalendarButton,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        vfair: {
            type: Object as PropType<VFair | null>,
            default: null,
        },
        loading: {
            type: Boolean,
            required: true,
        },
        ongoing: {
            type: Boolean,
            required: true,
        },
    },
    data(): DataType {
        return {
            isLoading: false,
            modalOpen: false,
        };
    },
    methods: {
        onLoadingChange(isLoading: boolean): void {
            this.isLoading = isLoading;
        },
        handleClose() {
            this.$emit('close');
        },
    },
    watch: {
        show(value: boolean) {
            if (value) {
                this.modalOpen = true;
            } else {
                const modal = this.$refs.scrollable as Element;
                if (!!modal) enableBodyScroll(modal);
                this.modalOpen = false;
            }
        },
        modalOpen(value: boolean) {
            if (!value) return;

            setTimeout(() => {
                const modal = this.$refs.scrollable as Element;
                if (!modal) return;
                disableBodyScroll(modal);
            }, 10);
        },
    },
});
